import moment from "moment"
import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { fetchAllJourneyData, fetchApplicationDetails, generateBI, pdfDownload, saveApplication, sendEmailBI, uploadDocument, whatsAppOptin, getTOFpaymentReceipt, saveTransactionDetails } from "../../../services/apiservice"
import { applyComma, lineCapital, maskInFormat, wordCapital } from "../../../shared/functions"
import { JourneyContext } from "../../context/journeyContext"
import { PageContext } from "../../context/pageContext"
import { ErrorContext } from "../../context/errorContext"
import { SectionContext } from "../../context/sectionContext"
import { findCurrentJourneyCode, getAge, getValueFromLookup, transformReceiptToTransaction } from "../../services/helperFunctions"
import * as lookup from "../../../../static/lookup.json"
import { ConditionContext } from "../../context/conditionContext"
import { errorToastr, successToastr } from "../../../services/error-handler"



export default function SmartJuniorBenefitIllustration(props) {

  const [proceedWithOption, setProceedWithOption] = useState("");
  let [isactive, setIsActive] = useState(true)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)

  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("now")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(true)
  const [location, setLocation] = useState()
  const [isChecked, setIsChecked] = useState(true)
  const [skipPayment, setSkipPayment] = useState(false)

  async function downloadLinkOfPdf(Base64Pdf) {
    // if(!location){
    //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
    //     Base64Pdf: Base64Pdf,
    //   })
    //   setLocation(result.data.location)
    //   window.open(result.data.location,"_self");
    // }else{
    //   window.open(location,"_self");
    // }
    const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(Base64Pdf)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], { type: "application/pdf" })
      window.navigator.msSaveOrOpenBlob(blob, fileName)
      return
    }
    // For Other Browsers
    const linkSource = "data:application/pdf;base64," + Base64Pdf
    const link = document.createElement("a")
    link.href = linkSource
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.addEventListener(
      "focus",
      function () {
        URL.revokeObjectURL(link.href)
      },
      { once: true }
    )
  }

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const downloadPdf = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    downloadLinkOfPdf(sendEmailPdfData)
  }

  const printPdf = async () => {
    if (pdfData) {
      printPdf1(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: biApiData?.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      printPdf1(pdfResult?.data?.Base64Pdf)
    }

    function printPdf1(base64Data) {
      const newWindow = window.open("", "", "width=100, height=100")
      if (newWindow) {
        const document = newWindow.document.open()
        document.close()
        newWindow.moveTo(0, 0)
        newWindow.resizeTo(window.screen.width, window.screen.height)
        const contentType = "application/pdf"
        const b64Data = base64Data
        const blob = b64toBlob(b64Data, contentType)
        const blobUrl = URL.createObjectURL(blob)
        document.write(`<iframe id="pdfDocument"
    src="${blobUrl}" 
    width="100%"
    height="100%"
    frameBorder="0" ></iframe>`)
        const docs = document.getElementById("pdfDocument")
        setTimeout(() => {
          docs.contentWindow.print()
        }, 1000)
      }
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
  }

  const sendEmail = async (callS3uploadPdf) => {
    if (!biApiData) {
      return
    }
    let payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
      TID: biApiData?.TransactionId || "",
    }
    sendEmailBI(payload).then(res => {
      console.log(res, "emailRes")
      if (res?.status) {
        successToastr(res.message)
      } else {
        errorToastr(res.message)
      }
    })
  }


  //async function to make API call
  const getData = async () => {
    console.log("journeyState", journeyState.journeyId);
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(
      applicationDetailsPayload
    )

    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
    }
    let journeyResult = await fetchAllJourneyData(payload)
    console.log("journeyresult", journeyResult);
    if (journeyResult?.lifeAssuredDetails?.proceedWith) {
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
    }
    if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
      setPayNowOrLater("later")
    }
    generateBI(payload).then(async data => {
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      setJourneyState(prev => {
        return {
          ...prev,
          // premium:
          //   journeyState.planOption === "IATML"
          //     ? JSON.parse(data?.data?.BIJson)[0].TOTAL_5
          //     : journeyState.planOption === "IBTML"
          //       ? (
          //         JSON.parse(data?.data?.BIJson)[0].TOTAL_BASE_PREM_TAX +
          //         JSON.parse(data?.data?.BIJson)[0].TOTAL_PREM_TAX_SPOUSE || 0
          //       )?.toFixed(2)
          //       : "",
          premium: Math.round(JSON.parse(data?.data?.BIJson)?.[0].MODAL_PREM_TAX) || 0,
          journeyData: applicationResult.applicationData,
        }
      })
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: data.data.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      setBiApiData(data.data)

      getTOFpaymentReceipt(journeyState.applicationNo)
      .then(res => {
        console.info(res);
        const receipts = res.data || [];
        const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
        let sum = 0;
        validReceipts.forEach(receipt => {
          sum += parseInt(receipt.amount);
        });
        if (sum >= (Math.round(JSON.parse(data.data.BIJson)?.[0].MODAL_PREM_TAX))) {
          setSkipPayment(true);
        }
        setJourneyState(prev => ({
          ...prev,
          receipts: validReceipts 
        }));
      })
      .catch(err => console.info(err));

    })
      .catch(err => {
        console.log("error in save application of save application and call BI function")
      })
  }

  //Use Effects
  useEffect(async () => {
    console.log("getdata callaed");
    await getData();
    console.log("bidattttaaaa", biApiData);
  }, [])

  // useEffect(() => {
  //   storePdfData()
  // }, [biApiData])

  //Page Functions
  const handlePayOption = ({ target }) => {
    console.log(target.value, "value in BI");
    if (target.value === "now") {
      setPayNowOrLater("now")
    } else if (target.value === "later") {
      setPayNowOrLater("later")
    }
  }

  const handlePrevious = () => {
    if (proceedWithOption === "manually") {
      props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
  }

  const handleProceed = async ev => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    console.log("tessttttttxxxxxxxxxxx", props);

    // downloadLinkOfPdf(pdfData);
    sendEmail(true);
    // const result = await s3uploadPdfBI({
    //   applicationNumber: journeyState.applicationNo,
    //   Base64Pdf: pdfData,
    // })
    // const b64Data = pdfData
    // const blob = b64toBlob(b64Data, "application/pdf")
    // let formData = new FormData()
    // if (blob) {
    //   const file = blob
    //   formData.append("doc", file)
    //   formData.append("sub", false)
    //   formData.append("docPurpose", "BIPDF")
    //   try {
    //     const res = await uploadDocument(formData, journeyState.applicationNo)
    //     console.log({ res })
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    // function b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || ""
    //   sliceSize = sliceSize || 512

    //   var byteCharacters = atob(b64Data)
    //   var byteArrays = []

    //   for (
    //     var offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize)

    //     var byteNumbers = new Array(slice.length)
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i)
    //     }

    //     var byteArray = new Uint8Array(byteNumbers)

    //     byteArrays.push(byteArray)
    //   }

    //   var blob = new Blob(byteArrays, { type: contentType })
    //   return blob
    // }

    if (payNowOrLater === "now") {
      console.log("tesstttttt", journeyState.journeySteps.pages);
      let temp = journeyState.journeySteps
      if (["fillProposalForm", "PageFlexiEdgeFillProposalForm"].includes(temp.pages[2].pageId)) {
        let element = temp.pages[3]
        temp.pages.splice(3, 1)
        temp.pages.splice(2, 0, element)
      }
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "N",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
      console.log("journeystateeee", journeyState);

    } else {
      console.log("tesstttttt", journeyState.journeySteps.pages);

      let temp = journeyState.journeySteps
      if (["makePayment"].includes(temp.pages[2].pageId)) {
        let element = temp.pages[3]
        temp.pages.splice(3, 1)
        temp.pages.splice(2, 0, element)
      }
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
    console.log("journeystateee222222222222222e", journeyState);
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
        },
        posDashboardListingData:{
          canaraPosCaseType: "sendCaseToCustomer"
        }
      // base64Data: pdfData,
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
  }

  const handleAgreeChange = () => {
    setAgreeToDeclaration(prev => !prev)
  }

  const handleProceedSkipPayment = (e) => {
    e.preventDefault();
  
    const temp = journeyState.journeySteps;
    console.log(temp);
    let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
    let fillProposalFormPageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm");
    let makePaymentPageSections = temp.pages[makePaymentPageIndex].sections;
    makePaymentPageSections = makePaymentPageSections.filter(section => section.sectionId === "eNach-physicalMandate");
    temp.pages[makePaymentPageIndex].sections = makePaymentPageSections;
    let tempPage = temp.pages[makePaymentPageIndex];
    temp.pages[makePaymentPageIndex] = temp.pages[fillProposalFormPageIndex];
    temp.pages[fillProposalFormPageIndex] = tempPage;
    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp
      }
    });
  
    let sendPayload = {
      applicationData: journeyState.journeyData,
      skipPayment:'Y',
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex + 1,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX) || 0,
        lastPageCode: props.pageId,
        paymentStep: "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
      },
      // base64Data: pdfData,
    }
  
    saveApplication(sendPayload).then(async res => {
      console.log(res, "application response");
      props.setCurrentPageIndex(prev => prev + 1);
      setErrorState({});
      props.setCurrentSectionIndex(0); // this moves to first section of next page
  
      // Save transaction details if skipPayment is true
      if (skipPayment) {
        const validReceipts = journeyState.receipts || [];
        const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
  
        const transactionPayload = {
          journeyId: journeyState.journeyId,
          applicationNumber: journeyState.applicationNo,
          status: 'Success',
          skipPayment: 'Y',
          transactions: transactions
        };
  
        let saveResp = await saveTransactionDetails(transactionPayload);
      }
      

    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration");
    });
  }

  const handleReCalculate = () => {
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)
      const tempPage = journeyState.journeyData[0]
      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: tempPage.pageData,
        }
      })
      const tempState = journeyState.journeyData[0].pageData[0]
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
  }

  const handleSendLinkToSales = (ev) => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    sendEmail(true);
    console.log("tesstttttt",journeyState.journeySteps.pages);
    let temp = journeyState.journeySteps

    temp.pages = temp.pages.filter(page => page.pageId !== "PageFlexiEdgeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "PageFlexiEdgeUploadDocuments")
    temp.pages.push(...lookup.sendLinktosales)
    if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
      temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
    }
    console.log(temp.pages)

    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        paymentStep: "L",
        journeyCode: findCurrentJourneyCode(
          props.pageId,
          props.sections[props.currentSectionIndex].sectionId
        ),
        canaraPosCaseType: "sendLinktosales"
      }
    })
  console.log("journeystateeee",journeyState);
  setSectionState(prev => {
    // making section data empty to load new sectionData
    return {
      ...prev,
      sectionId: null,
      sectionFirstPass: null,
      sectionData: {},
    }
  })
  // let optInPayload = {
  //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
  // }
  // let whatsAppOptres = whatsAppOptin(optInPayload)
  let sendPayload = {
    applicationData: journeyState.journeyData,
    journeyData: {
      _id: journeyState.journeyId,
      lastPage: props.currentPageIndex,
      lastSection: props.currentSectionIndex,
      applicationNo: journeyState.applicationNo,
      illustrationNumber: journeyState.illustrationNumber,
      proposalEntryId: journeyState.proposalEntryId,
      lastPageCode: props.pageId,
      paymentStep: payNowOrLater === "now" ? "N" : "L",
      lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
      planOption: journeyState.planOption,
      canaraPosCaseType: "sendLinktosales"
    },
    posDashboardListingData:{
      canaraPosCaseType: "sendLinktosales"
    }
  }
  saveApplication(sendPayload).then(res => {
    console.log(res, "application response")
    successToastr('Application will be visible on sales Dashboard after SCR Declaration')
    props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
  }).catch(err => {
    console.log(err, "err in saveApplication benefit-illustration")
  })
  }

  
// console.info(JSON.parse(biApiData?.BIJson),"allJourneyDatdadaa")
  if (allJourneyData && biApiData) {
    console.log("allJourneyData", allJourneyData, biApiData && JSON.parse(biApiData?.BIJson), biApiData && JSON.parse(biApiData?.BIJson))
  }
  const RadioContainer = styled.div`
      width: 100%;
      display: block;
      flex-direction: column;
      margin: 15px 0;
      position: relative;
      box-sizing: border-box;
      font-size: 15px;
      color: #505050;
      float: left;
    
      & > label {
        margin-left: 8px;
        margin-bottom: 5px;
        color: #505050;
        font-size: 16px;
        background-color: #fff;
        padding: 2px 5px;
        z-index: 999;
        position: relative;
        display: inline-block;
        cursor: default;
        max-width: 100%;
        & > .radio-label {
          text-align: center;
        }
      }

    
      .card {
        border-radius: 1rem;
        padding: 1rem 0;
        border-radius: 15px;
        background-color: #fff;
        position: relative;
        margin: 0px;
        margin-bottom: 0px;
        cursor: pointer;
        height: 9rem;
        margin-top: 0px;
        box-shadow: 0px 0px 20px #ccc;
        transition: all 200ms;
    
        .amount {
          color: black;
          margin-bottom: 1rem;
          margin-left: 6rem;
          border-left: 1px solid #ccc;
          padding-left: 2rem;
          height: 3rem;
          font-size: 20px;
          padding-top: .5rem;
        }
        .desc {
          padding: 0.5rem;
          background: #ededed;
          color: black;
          text-align: center;
        }
      }
    
      /*Check tick start  */
      .checked {
        background: #ededed;
        color: #ededed;
        position: absolute;
        left: 1.5rem;
        top: 1.5rem;
        height: 2rem;
        width: 2rem;
        border-radius: 50%;
        padding: 8px;
        & > * {
          font-size: 1.2rem;
        }
      }
    
      input:checked ~ .card .checked {
        background: #fff;
        
        color: var(--lumiq-card-bg);
      }
      /*Check tick end */
    
      .icon-container {
        font-size: 3rem;
        padding: 1rem;
        span {
          border-radius: 50%;
          padding: 1rem;
    
          background: #3e505d;
          .hero-icon {
            padding-top: 8px;
            color: #fff;
          }
        }
      }
    
      input:checked ~ .card {
        background-color: #2293e4;
        color: #fff;
        .icon-container-1 {
          span {
            background: #fff;
            .hero-icon {
              color: #3e505d;
            }
          }
        }
    
        .amount {
          color: white;
          margin-bottom: 1rem;
          margin-left: 6rem;
          border-left: 1px solid #ccc;
          padding-left: 2rem;
          padding-top: .5rem;
          height: 3rem;
        }
        .desc {
          padding: 0.5rem;
          background: #fff;
          color: black;
          text-align: center;
        }
      }
    
      input:not(:checked) ~ .card {
        /* opacity: 0.5; */
        .amount{
          color:#818181;
        }
    
        .desc{
          color:#3e505d;
        }
      }
    `
  return (
    <>
      <style>
        {`
                .application-design-number {
                    background-color: #0088c4;
                    padding: 5px 15px;
                    font-size: 15px;
                    color: #fff;
                    text-align: center;
                    width: 268px;
                    display: inline-block;
                    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                    border-radius: 7px;
                }
        .table-color-dark{
          background:#e9e9e9 !important;
        }
        .iselect-heading {
            color: #0087c3;
            font-size: 25px;
            margin: 0px;
            font-family: 'HelveticaNeue LT 55 Roman';
            padding-left: 0px;
            margin-left: 19px;
        }
        
      .iselect-heading:before {
        position: absolute;
        content: "";
        width: 5px;
        height: 28px;
        background-color: #f8be15;
        left: 20px;
    }
        .table-color-grey{
          background:#e9e9e9 !important;
        }
        .container{
          max-width: 980px;
        }
        .option-buit-design-new-new-design::after{
          height: 2rem
        }
        .shadow-box-card{
          background-color: #fff;
          box-shadow: 0px 0px 10px #ccc;
          border-radius: 10px;
          padding: 0px 0px;
          float: left;
          width: 100%;
          margin-bottom: 30px;
          height: 172px;
        }
        .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
          background-color: #ededed;
          left: 0px;
          top: 0px;
        }
        radio-line{
          width: 100%;
          height: 100%
        }
        .customradio{
          padding: 22px 0px
        }
        .customradio .checkmark {
          top: 22px !important;
        }
        .by-pay{
          bottom: 8px
        }
        resent-bi-center{
          position: relative;
          margin: 20px auto;
        }
        .eky-resend {
          margin: auto;
          right: 25px;
          position: relative;
          left: 4px
        }
        .custom-otp{
          margin: auto
        }
        .total-mt-design {
            background-color: #0088c4;
            padding: 10px;
            text-align: center;
            font-weight: bold;
            color: #fff;
            border-radius: 7px;
        }
        .table-color-dark{
            background:#e3e3e3b8;
        }
        .Bi-Achitecture{
            display:flex;

        }
        .table-bg .table{
            color:#767272;
        }
        .table-design .table-bg .table-color-dark td{
            padding:14px;
        }
        @media screen and (max-width:991px){
            .Bi-Achitecture{
                display:flex;
                flex-direction:column;
            }
        }
        @media (max-width: 767px)
          .table-responsive {
              
          }
          table-design .table-bg {
            
          }
          .Bi-design-structure-table .table-design .table-bg td {
            padding: 7px !important;
          }
        }
      
      `}

      </style>
      <style>
        {`
                .resent-bi-center {
                    float: none;
                    margin: 20px auto;
                }
                .previous-btn {
                    padding: 14px 0px;
                    background-color: rgb(248, 190, 21);
                    border-radius: 10px;
                    margin: 0px 10px;
                    margin-right: 0px;
                    transition: 0.5s;
                    border-radius: 10px;
                    text-align: center;
                }
        .headline-table {
            background-color: #0088c4;
            color: #fff;
            text-align: center;
            font-weight: bold;
            font-size: 18px !important;
            letter-spacing: 1px;
            margin: 0px;
            padding: 13px;
        }
        .table-color-dark{
          background:#e9e9e9 !important;
        }

        .container{
          max-width: 980px;
        }

        .option-buit-design-new-new-design::after{
          height: 2rem
        }
        .shadow-box-card{
          background-color: #fff;
          box-shadow: 0px 0px 10px #ccc;
          border-radius: 10px;
          padding: 0px 0px;
          float: left;
          width: 100%;
          margin-bottom: 30px;
          height: 172px;
        }
        .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
          background-color: #ededed;
          left: 0px;
          top: 0px;
        }
        radio-line{
          width: 100%;
          height: 100%
        }
        .customradio{
          padding: 22px 0px
        }
        .customradio .checkmark {
          top: 22px !important;
        }
        .by-pay{
          bottom: 8px
        }

        .eky-resend {
          margin: auto;
          right: 25px;
          position: relative;
          left: 4px
        }
        .custom-otp{
          margin: auto
        }
        .table-color-dark{
            background:#e3e3e3b8;
        }
        .Bi-Achitecture{
            display:flex;

        }
        .table-bg .table{
            color:#767272;
        }
        .table-design .table-bg .table-color-dark td{
            padding:14px;
        }
        @media screen and (max-width:991px){
            .Bi-Achitecture{
                display:flex;
                flex-direction:column;
            }
        }
        @media (max-width: 767px)
          .table-responsive {
              border: none;
          }
          table-design .table-bg {
            border: 1px solid #d6d6d6;
          }
          .Bi-design-structure-table .table-design .table-bg td {
            padding: 7px;
          }
        }

      `}

      </style>
     {allJourneyData && biApiData && ( <div class="container">
        <form id="declaration-form" name="declaration-form" action="" method="post" autocomplete="off" novalidate="novalidate">
          <div class="iselect-box-design">
            <div class="heading-design">
              <div class="iselect-padding left-side-head ckyc-w">
                <h1 class="iselect-heading">Benefit Illustration</h1> <span class="subhead">Canara HSBC Life Insurance Smart Junior Plan    &nbsp; | &nbsp; UIN: 136N043V03</span> </div>
              <div class="app-quatation mt hidden-desktop-screen">
                <div class="application-design-number">Application Number: {journeyState?.applicationNo}</div>
              </div>
            </div>
            <div class="iselect-padding">
              <div class="bi-summary">
                <div class="auther-description mt-20">
                  <h3>Dear &nbsp;<span style={{ "fontSize": "1.3rem", "fontStyle": "italic", "fontWeight": "bold" }}>
                  {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                  </span></h3>
                  <p class="benefit-title">Thank you for showing interest in our Canara HSBC Life Insurance Smart Junior Plan. Based on the details provided by you, and reproduced below, the illustration customised to your requirements is appended. </p>
                  <p class="benefit-title"> Please note that this illustration is indicative and the actual values may vary depending on performance of the participating fund managed by the Company.</p>
                </div>
              </div>
              <div class="Bi-design-structure-table mt-50 iselect-mg-bottom">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="table-responsive table-design">
                      <h2 class="headline-table">Personal Details of Life to be Assured</h2>
                      <div class="table-bg">
                        <table class="table">
                          <tbody>
                            <tr class="table-color-grey">
                              <td> Date of Birth </td>
                              <td align="right">{allJourneyData?.lifeAssuredDetails?.dob ? maskInFormat(allJourneyData?.lifeAssuredDetails?.dob * 1000) : "NA"}</td>
                            </tr>
                            <tr class="table-color">
                              <td>Age</td>
                              <td align="right"> {getAge(allJourneyData?.lifeAssuredDetails?.dob)} Years</td>
                            </tr>
                            <tr class="table-color-grey">
                              <td>Designation </td>
                              <td align="right">{lineCapital(getValueFromLookup("natureOfOccupation", allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation))} &amp; {lineCapital(getValueFromLookup("natureOfIndustry", allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry))} </td>
                            </tr>
                            <tr class="table-color">
                              <td> Gender </td>
                              <td align="right">{lineCapital(getValueFromLookup("gender", allJourneyData?.lifeAssuredDetails?.gender))}</td>
                            </tr>
                            <tr class="table-color-grey">
                              <td>Date of Illustration </td>
                              <td align="right">{allJourneyData?.basicDetails?.applicationNoGenerationTime ? moment.unix(allJourneyData?.basicDetails?.applicationNoGenerationTime).utcOffset("+05:30").format("DD/MMM/YYYY") : "NA"}</td>
                            </tr>
                            <tr class="table-color">
                              <td>Sum Assured(<span class="fa fa-rupee"></span>)</td>
                              <td align="right"> <span class="fa fa-rupee"></span>{allJourneyData ? ` ${applyComma(Math.round(allJourneyData.productDetails?.sumAssured))}` : "NA"}</td>
                            </tr>
                            <tr class="table-color-grey">
                              <td>Illustration for Standard Life</td>
                              <td align="right">Illustration for Standard Life</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row inside-row">
                      <div class="col-lg-12 pr pl">
                        <div class="table-responsive table-design">
                          <h2 class="headline-table">Plan Details </h2>
                          <div class="table-bg">
                            <table class="table">
                              <tbody>
                                <tr class="table-color-grey">
                                  <td> Proposal Number </td>
                                  <td align="right"> {allJourneyData?.basicDetails?.applicationNumber} </td>
                                </tr>
                                <tr class="table-color">
                                  <td>Name of the Plan </td>
                                  <td align="right">Canara HSBC Life Insurance Smart Junior Plan </td>
                                </tr>
                                <tr class="table-color-grey">
                                  <td>Policy Term </td>
                                  <td align="right"> {biApiData ? `${JSON.parse(biApiData.BIJson)?.[0].POLICYTERM}` : "NA"}</td>
                                </tr>
                                <tr class="table-color">
                                  <td> Premium Payment Term </td>
                                  <td align="right"> {allJourneyData?.productDetails?.premiumPaymentTerm} </td>
                                </tr>
                                <tr class="table-color-grey">
                                  <td>Premium Payment Frequency</td>
                                  <td align="right">{lineCapital(getValueFromLookup("MoneyBackPaymentFrequency", allJourneyData?.productDetails?.premiumFrequency) ?? '') || "NA"} </td>
                                </tr>
                                <tr class="table-color">
                                  <td>Annualised Premium </td>
                                  <td align="right">{biApiData ? `₹ ${applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].ANN_PREM_YEARLY))}` : "NA"} </td>
                                </tr>
                                <tr class="table-color-grey">
                                  <td>Installment Premium Year 1 (without Goods and Services Tax &amp; Cess (es)/ levy, if any)</td>
                                  <td align="right">{biApiData ? `₹ ${applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM))}` : "NA"}</td>
                                </tr>
                                <tr class="table-color">
                                  <td>Installment Premium Year 2 onwards (without Goods and Services Tax &amp; Cess (es)/ levy, if any):</td>
                                  <td align="right">{biApiData ? `₹ ${applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[1].MODAL_PREM))}` : "NA"}</td>
                                </tr>
                                <tr class="table-color-grey">
                                  <td>Installment Premium for Year 1 (with Goods and Services Tax &amp; Cess (es)/ levy, if any):</td>
                                  <td align="right">{biApiData ? `₹ ${applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX))}` : "NA"}</td>
                                </tr>
                                <tr class="table-color">
                                  <td>Installment Premium from Year 2 onwards (with Goods and Services Tax &amp; Cess (es) levy, if any):</td>
                                  <td align="right">{biApiData ? `₹ ${applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[1].MODAL_PREM_TAX))}` : "NA"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-lg-12 pl-pr">
                  <div class="total-mt-design"> <span>Total Maturity Value (8%) - {biApiData ? `₹ ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)?.[JSON.parse(biApiData?.BIJson)?.length-1].TOTAL_SB_BS_2))}` : "NA"}</span>  <span> |</span> <span> Total Maturity Value (4%) - {biApiData ? `₹ ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)?.[JSON.parse(biApiData?.BIJson)?.length-1].TOTAL_SB_BS_1))}` : "NA"}</span> </div>
                </div>
              </div>
              <div class="transactionDetailsWrap">
                <div class="detailContentWrap">
                  <div class="row">
                    <div class="buttonWrap">
                      <div class="button submit-btn"  aria-hidden="true" onClick={downloadPdf} ><a> Download</a></div>
                      <div class="button submit-btn" aria-hidden="true" onClick={printPdf}><a> Print</a></div>
                      <div class="button submit-btn" aria-hidden="true" onClick={() => { sendEmail(true) }} ><a> Email</a></div>
                      <div class="button submit-btn" aria-hidden="true" onClick={handleReCalculate}><a>Re-Calculate</a></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div class="clearfix"></div>
              <div class="row iAgree ls3 text-center mt-20">
                <div class="form-group">
                  <div class="inner-addon left-addon">
                    <div class="checkbox1">
                      <input name="checkboxG6" id="checkboxG6" class="css-checkbox" type="checkbox" onChange={handleAgreeChange}  />
                      <label for="checkboxG6" class="css-label"> I agree to the Disclosures and Disclaimers as mentioned below </label>
                    </div>
                  </div>
                </div>
              </div> */}
              <div class="clearfix"></div>
              <div class="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                <div class="row">
                  <div class="col-lg-12 pl-pr">
                    <div class="option-buit-design-new-structure-box">
                      <div class="option-buit-design-new-structure-selected">
                      {allJourneyData?.journeyType !== "CanaraPos" && !skipPayment && (
                          <div className="option-buit-design-new-structure-selected">
                            <div className="row">
                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="now"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "now" ? true : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Now!
                                          </span>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Pay your{" "}
                                            {lineCapital(
                                              getValueFromLookup(
                                                "biFrequencyLabel",
                                                allJourneyData?.productDetails
                                                  ?.premiumFrequency
                                              ) ?? ""
                                            ) || "NA"}{" "}
                                            Premium{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            now and proceed.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>

                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="later"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "later"
                                            ? true
                                            : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Later!
                                          </span>
                                          <div></div>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Continue with your application and
                                            pay
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            later.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>
                            </div>
                          </div>
                      )}
                      {skipPayment && <p style={{
                        textAlign : "center",
                        fontSize : "18px",
                        marginTop : "30px"

                      }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) : "NA"}`} is adjusted against transfer of funds from old application</p>} 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="clearfix"></div>
              <div class="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="but-center text-center">
                    {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    }
                      <div class="previous-btn cen" style={{padding:"0px"}}>

                        <a style={{padding:"0px"}}>
                          <button type="submit" aria-hidden="true" onClick={skipPayment ? handleProceedSkipPayment : handleProceed} style={{ backgroundColor: "transparent", padding: "14px 40px",borderRadius:"10px", border: "none", color: "#fff" }}>Proceed</button>
                        </a>
                      </div>
                      {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div className="mobile-view-btn-Q1 pd-mobile-space-structure canara-pos-bi-btn">
          <div className="iselect-mg-bottom">
            <div className="row">
              <div className="col-lg-12">
                <div className="but-center text-center">
                {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        style={{ paddingLeft: "5px" }}
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          style={{ paddingLeft: "5px" }}
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                  <input className="previous-btn cen bi-btv"  onClick={skipPayment ? handleProceedSkipPayment : handleProceed} style={{ color: "white", padding: "14px 0px", border: "none", marginLeft: "10px", width: "160px", backgroundColor: "#f8be15" }} type="button" form="aDetail" align="right" value="Proceed" />
                  {allJourneyData?.journeyType === "CanaraPos" &&
                    <div className="previous-btn cen send-link-to-cust">
                        <span>
                          <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                        </span>
                    </div>
                  }
                  {/* <div className="previous-btn cen send-link-to-cust">
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                        <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                    }
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>)}
    </>
  )
}
